webpackJsonp([70144966829960],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactStyled = _styledComponents2.default.section.withConfig({
	  displayName: 'contact__ContactStyled',
	  componentId: 'sc-5gqltf-0'
	})(['max-width:', ';margin:0 auto;article{max-width:68ch;line-height:1.7;margin-bottom:1.25rem;}form{margin-top:2rem;width:100%;max-width:44rem;box-sizing:border-box;display:grid;gap:0.9rem;padding:1.25rem;border-radius:14px;background:rgba(255,255,255,0.96);}label{font-size:0.92rem;font-weight:600;letter-spacing:0.01em;color:', ';}input,textarea{width:100%;box-sizing:border-box;font:inherit;color:', ';background-color:rgba(255,255,255,0.98);border:1px solid rgba(0,0,0,0.16);border-radius:10px;padding:0.95rem 1rem;box-shadow:inset 0 1px 2px rgba(0,0,0,0.03);transition:border-color 160ms ease,box-shadow 160ms ease,transform 160ms ease,background-color 160ms ease;}input::placeholder,textarea::placeholder{color:rgba(0,0,0,0.44);}input:focus,textarea:focus{outline:none;border-color:', ';box-shadow:0 0 0 4px rgba(59,16,187,0.12);background-color:#fff;}textarea{min-height:12rem;resize:vertical;line-height:1.6;}.turnstile-slot{display:flex;justify-content:flex-start;margin-top:0.25rem;}.contact-status{margin-top:0.25rem;text-align:left;font-size:0.95rem;line-height:1.5;}.contact-error{color:#b00020;}button{justify-self:start;padding:0.78rem 1.05rem;border:1px solid rgba(0,0,0,0.22);border-radius:6px;background:rgba(255,255,255,0.92);color:', ';font:inherit;font-weight:600;line-height:1;transition:background-color 160ms ease,border-color 160ms ease,transform 160ms ease;}button:hover:not([disabled]){transform:translateY(-1px);background:rgba(255,255,255,1);border-color:rgba(0,0,0,0.32);cursor:pointer;}button:focus{outline:none;border-color:rgba(0,0,0,0.4);box-shadow:0 0 0 3px rgba(0,0,0,0.08);}button[disabled]{opacity:0.7;cursor:wait;}@media (max-width:640px){form{padding:1rem;border-radius:12px;}}'], _constants.maxMainWith, _constants.colors.darkTextColor, _constants.colors.darkTextColor, _constants.colors.gradientTop, _constants.colors.darkTextColor);
	
	var initialFields = {
	  name: '',
	  email: '',
	  message: ''
	};
	
	var ContactPage = function ContactPage() {
	  var siteKey = ("0x4AAAAAADvgaZ8PDLx8YHin") || '';
	
	  var _useState = (0, _react.useState)(initialFields),
	      fields = _useState[0],
	      setFields = _useState[1];
	
	  var _useState2 = (0, _react.useState)('idle'),
	      status = _useState2[0],
	      setStatus = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      errorMsg = _useState3[0],
	      setErrorMsg = _useState3[1];
	
	  var turnstileRef = (0, _react.useRef)(null);
	  var widgetIdRef = (0, _react.useRef)(null);
	  var tokenRef = (0, _react.useRef)('');
	
	  (0, _react.useEffect)(function () {
	    if (!siteKey) return undefined;
	
	    var scriptSrc = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
	    var existingScript = document.querySelector('script[src="' + scriptSrc + '"]');
	
	    if (existingScript) {
	      return undefined;
	    }
	
	    var script = document.createElement('script');
	    script.src = scriptSrc;
	    script.async = true;
	    script.defer = true;
	    document.head.appendChild(script);
	
	    return undefined;
	  }, [siteKey]);
	
	  (0, _react.useEffect)(function () {
	    if (!siteKey || !turnstileRef.current) return undefined;
	
	    var cancelled = false;
	
	    var render = function render() {
	      if (cancelled) return;
	
	      if (typeof window.turnstile === 'undefined') {
	        window.setTimeout(render, 200);
	        return;
	      }
	
	      if (widgetIdRef.current || !turnstileRef.current) return;
	
	      widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
	        sitekey: siteKey,
	        callback: function callback(token) {
	          tokenRef.current = token;
	        },
	        'expired-callback': function expiredCallback() {
	          tokenRef.current = '';
	        },
	        theme: 'dark'
	      });
	    };
	
	    render();
	
	    return function () {
	      cancelled = true;
	
	      if (widgetIdRef.current && typeof window.turnstile !== 'undefined') {
	        window.turnstile.remove(widgetIdRef.current);
	        widgetIdRef.current = null;
	      }
	    };
	  }, [siteKey]);
	
	  function handleSubmit(event) {
	    event.preventDefault();
	
	    if (siteKey && !tokenRef.current) {
	      setErrorMsg('Please complete the Turnstile challenge before sending the form.');
	      return;
	    }
	
	    setStatus('loading');
	    setErrorMsg('');
	
	    fetch('/api/contact', {
	      method: 'POST',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      body: JSON.stringify({
	        name: fields.name,
	        email: fields.email,
	        message: fields.message,
	        turnstile_token: tokenRef.current || 'dev'
	      })
	    }).then(function (response) {
	      return response.json().catch(function () {
	        return {};
	      }).then(function (data) {
	        return { response: response, data: data };
	      });
	    }).then(function (_ref) {
	      var response = _ref.response,
	          data = _ref.data;
	
	      if (!response.ok) {
	        throw new Error(data.error || 'There was a problem sending the message.');
	      }
	
	      setFields(initialFields);
	      setStatus('idle');
	      tokenRef.current = '';
	
	      if (widgetIdRef.current && typeof window.turnstile !== 'undefined') {
	        window.turnstile.reset(widgetIdRef.current);
	      }
	
	      window.location.assign('/thanks/');
	    }).catch(function (error) {
	      setStatus('error');
	      setErrorMsg(error instanceof Error ? error.message : 'Unexpected error');
	
	      if (widgetIdRef.current && typeof window.turnstile !== 'undefined') {
	        window.turnstile.reset(widgetIdRef.current);
	        tokenRef.current = '';
	      }
	    });
	  }
	
	  return _react2.default.createElement(
	    ContactStyled,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Contact - Roberto V\xE1zquez Gonz\xE1lez Site'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'Contact Me'
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      'If you have any questions about my professional experience and/or skills or just want to get in touch, do not hesitate to use the following form.'
	    ),
	    _react2.default.createElement(
	      'form',
	      { onSubmit: handleSubmit },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'name' },
	        'Name'
	      ),
	      _react2.default.createElement('input', {
	        id: 'name',
	        name: 'name',
	        type: 'text',
	        autoComplete: 'name',
	        placeholder: 'What\'s your name?',
	        value: fields.name,
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          setFields(function (current) {
	            return _extends({}, current, {
	              name: value
	            });
	          });
	        }
	      }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'email' },
	        'Email'
	      ),
	      _react2.default.createElement('input', {
	        id: 'email',
	        name: 'email',
	        type: 'email',
	        autoComplete: 'email',
	        placeholder: 'And your email?',
	        value: fields.email,
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          setFields(function (current) {
	            return _extends({}, current, {
	              email: value
	            });
	          });
	        },
	        required: true
	      }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'message' },
	        'Message'
	      ),
	      _react2.default.createElement('textarea', {
	        id: 'message',
	        name: 'message',
	        cols: '30',
	        rows: '10',
	        placeholder: 'What do you want to say?',
	        value: fields.message,
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          setFields(function (current) {
	            return _extends({}, current, {
	              message: value
	            });
	          });
	        },
	        required: true
	      }),
	      siteKey ? _react2.default.createElement('div', { ref: turnstileRef, className: 'turnstile-slot' }) : null,
	      errorMsg ? _react2.default.createElement(
	        'p',
	        { className: 'contact-status contact-error' },
	        errorMsg
	      ) : null,
	      _react2.default.createElement(
	        'button',
	        { type: 'submit', disabled: status === 'loading' },
	        status === 'loading' ? 'Sending...' : 'Send it!'
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-3a8367e9666c139218b2.js